import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { ChangeDetectionStrategy } from '@angular/core';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

declare const Rut: any;
declare const ageCalculator: any;

export interface DialogData {
  rut: any,
  dv: any,
  termino: any,
  motivo: string,
  fechaDesafiliacion: any
  fechaRechazo: any
}

@Component({
  selector: 'app-desafiliar-afiliacion',
  templateUrl: '../../pages/afiliacion/dialog-desafiliar-afiliacion.component.html',
  styleUrls: ['../../pages/solicitud-afiliacion/solicitud-afiliacion.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DialogDesafiliarAfiliacionComponent implements OnInit, OnDestroy {

  nombreUsuario: string = localStorage.getItem("nombreUsuario")
  rutAfiliado: string = localStorage.getItem("rutAfiliado")
  idEjecutivo = localStorage.getItem("idUsuario")
  rutUsuario: any;
  fechaRechazo: any;
  motivo: string;
  termino: any;
  rut: any;
  mostrarDatosCargados: boolean;
  cursos: any[]; postulantes: any[];
  afiliado: any = { rut: "", sub: "", name: "", nombres: "", idAfiliado: '', email: '', nombreAfiliado: '', apellidoAfiliado: '' };

  constructor(private router: Router,
    public dialogRef: MatDialogRef<DialogDesafiliarAfiliacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog,
    private postulacionesService: PostulacionesService,
    private afiliacionService: AfiliacionService) {
    let vm = this
    this.data.termino = false
  }

  ngOnInit(): void {
  }


  ngOnDestroy(): void {
  }



  casoExitoso() {
    this.router.navigate(['/login'])
  }
  casoFallido() {
    this.router.navigate(['/solicitud-afiliacion'])
  }


  onDesafiliarAfiliado(form: NgForm) {
    let vm = this;
    vm.termino = false

    if (!form.form.value.fechaDesafiliacion) {
      this.openAlertDialog('Debe ingresar la fecha de desafiliacion', 'btn-danger')
      Swal.close();
      return false
    }

    if (!form.form.value.motivo) {
      this.openAlertDialog('Debe ingresar el motivo de rechazo', 'btn-danger')
      Swal.close();
      return false
    }

    let fechaDesafiliacionTemp = ''
    if (form.form.value.fechaDesafiliacion) {
      fechaDesafiliacionTemp = form.form.value.fechaDesafiliacion.split('-')[2] + '-' + form.form.value.fechaDesafiliacion.split('-')[1] + '-' +
        form.form.value.fechaDesafiliacion.split('-')[0]
    } else {
      vm.openAlertDialog('El campo fecha de afiliación no debe ir vacio', 'btn-danger')
      Swal.close();
      return false;
    }


    const dialogRef = this.dialog.open(ConfirmationDialog,
      {
        data: { message: '¿Esta seguro desafiliar al afiliado?   ', buttonText: { ok: 'Si', cancel: 'No' } }
      })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        Swal.fire({
          allowOutsideClick: false,
          icon: 'info',
          text: 'Cargando...'
        });
        Swal.showLoading();
        this.afiliacionService.desafiliarAfiliado(vm.data.rut, fechaDesafiliacionTemp, form.form.value.motivo, vm.idEjecutivo).then
          (
            response => {
              Swal.close();
              this.dialogRef.close()
              vm.termino = true
              vm.data.termino = true

            }
          )
          .catch
          (
            () => {
              Swal.close();
            }
          )
      }
    })

  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  onCancelarClick(): void { this.dialogRef.close() }
}
